// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 获取当前用户 登录只负责获取 Token 并持久化，应用初始化时再携带 Token 去请求专门的currentUser接口获取完整信息。 GET /api/user/currentUser */
export async function getUserCurrentUser(options?: { [key: string]: any }) {
  return request<{
    code: number;
    message: string;
    data: {
      userId: string;
      name: string;
      role: "admin" | "sales" | "checker" | "factory" | "finance" | "warehouse";
      phone: string;
    };
  }>("/api/user/currentUser", {
    method: "GET",
    ...(options || {}),
  });
}

/** 删除用户 POST /api/user/delete */
export async function postUserOpenApiDelete(
  body: {
    userId: string;
  },
  options?: { [key: string]: any }
) {
  return request<{ code: number; message: string }>("/api/user/delete", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取用户详情 GET /api/user/details */
export async function getUserDetails(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getUserDetailsParams,
  options?: { [key: string]: any }
) {
  return request<{
    code: number;
    message: string;
    data: { name: string; role: string; phone: string };
  }>("/api/user/details", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取用户名ID 获取用户名，id GET /api/user/getName */
export async function getUserGetName(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getUserGetNameParams,
  options?: { [key: string]: any }
) {
  return request<{
    code: number;
    message: string;
    data: {
      list: {
        userId: string;
        userName: string;
        role:
          | "sales"
          | "checker"
          | "warehouse"
          | "finance"
          | "admin"
          | "factory";
      }[];
    };
  }>("/api/user/getName", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取用户列表 GET /api/user/list */
export async function getUserList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getUserListParams,
  options?: { [key: string]: any }
) {
  return request<{
    code: number;
    message: string;
    data: {
      list: {
        userId: string;
        name: string;
        role:
          | "admin"
          | "factory"
          | "sales"
          | "finance"
          | "warehouse"
          | "checker";
        phone: string;
      }[];
      total: number;
      page: number;
      pageSize: number;
    };
  }>("/api/user/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 用户账号密码登录 POST /api/user/login */
export async function postUserLogin(
  body: {
    username: string;
    password: string;
  },
  options?: { [key: string]: any }
) {
  return request<{ code: number; message: string; data: { token: string } }>(
    "/api/user/login",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 更新/新建用户 POST /api/user/save */
export async function postUserSave(
  body: {
    /** null表示新建；not null 为更新 */
    userId?: string;
    name: string;
    password: string;
    role: "admin" | "checker" | "sales" | "warehouse" | "finance" | "factory";
    phone: string;
    permissions?: string;
  },
  options?: { [key: string]: any }
) {
  return request<{ code: number; message: string }>("/api/user/save", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
